// ACHTUNG!!! SEO-kritische Komponente, Direkte Importe und Backendaufrufe sollten so gering wie nur möglich gehalten werden 


import { HttpClient } from '@angular/common/http';
import { Component, Input, OnInit, ViewChild, ChangeDetectionStrategy } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { isNullish } from '@commonHelpers/math-utils';
import { NgbModal, NgbModalOptions } from '@ng-bootstrap/ng-bootstrap';
import { CatalogDetailsType } from '@enums/catalog-details-type';
import { environment } from '@environments/environment';
import { CatalogViewCatalogInformationDto, Client as CatalogViewAPI } from '@interfaces/HttpClient/CatalogApiCatalogViewModels';
import { ContactFormType } from '@interfaces/HttpClient/CatalogApiPublicModels';
import { ICatalogQueryParams, ICatalogRoutingParams } from '@interfaces/iCatalogRoutingParams';
import { IContactFormOpen } from '@interfaces/iContactFormOpen';
import { CatalogTreeService } from '@services/catalog-tree.service';
import { CatalogViewService } from '@services/catalog-view.service';
import { TranslationService } from '@services/translation.service';
import { CatalogDetailsComponent } from "../catalog-details/catalog-details.component";
import { SoftwarepartnerApiService } from '@services/softwarepartner-api.service';

@Component({
    changeDetection: ChangeDetectionStrategy.Eager,
    selector: 'app-catalog-mobile-details',
    providers: [
        CatalogTreeService,
        CatalogViewService,
        {
            provide: CatalogViewAPI,
            useFactory: (http: HttpClient) => new CatalogViewAPI(http, environment.catalogApi),
            deps: [HttpClient]
        }
    ],
    templateUrl: './catalog-mobile-details.component.html',
    styleUrls: ['./catalog-mobile-details.component.scss'],
    imports: [CatalogDetailsComponent]
})
export class CatalogMobileDetailsComponent implements OnInit {

	@Input() catalog: CatalogViewCatalogInformationDto;
	@Input() catalogKey: string;
	@ViewChild("catalogDetails") catalogDetails: CatalogDetailsComponent;
	public catalogDetailsType = CatalogDetailsType.Public;
	public url: string;
	public catalogRoutingParams: ICatalogRoutingParams;
	public catalogQueryParams: ICatalogQueryParams;

	constructor(
		private route: ActivatedRoute,
		private router: Router,
		private modalService: NgbModal,
		private translationService: TranslationService,
		private softwarepartnerApiService: SoftwarepartnerApiService) {

	}


	ngOnInit(): void {
		this.route.params.subscribe(async params => {
			this.url = this.router.url;
			this.catalogRoutingParams = params;

			// Bugfix #34739: Wenn in der Softwarepartner API im Mobile-Modus ein CatalogItem direkt per URL aufgerufen wird, dann muss dieses als selektiert markiert werden.
			// Über den üblichen sonst Mechanismus per Tree funktioniert das in diesem Fall nicht, da der Tree und Detail-Ansicht im Mobile-Modus nicht gleichzeitig angezeigt werden.
			if(this.softwarepartnerApiService.hasSession()){
				this.softwarepartnerApiService.setSelectedCatalogItemsIfSelectionEmpty([], {guid: this.catalogRoutingParams.catalogItemGuid})
			}	
		});
		this.route.queryParams.subscribe(async params => {
			this.catalogQueryParams = params;
		});
	}

	async openContactForm(item: IContactFormOpen) {
		const catalogInfoOrPosition = this.catalogRoutingParams.catalogItemGuid ? this.catalogDetails.currentMainAttachment?.title : this.translationService.getByKey('catalog-view.roottitle');
		const options: NgbModalOptions = {
			backdrop: 'static',
			modalDialogClass: 'contact-form'
		};
		const contactForm = (await import('@app/components/contact-form/contact-form.component')).ContactFormComponent
		const modalRef = this.modalService.open(contactForm, options);
		modalRef.componentInstance.catalog = this.catalog;
		modalRef.componentInstance.catalogItemGuid = this.catalogRoutingParams.catalogItemGuid ? this.catalogRoutingParams.catalogItemGuid : undefined;
		modalRef.componentInstance.catalogInfoOrPosition = catalogInfoOrPosition;
		if (!isNullish(item.personId)) {
			modalRef.componentInstance.contactPersonId = item.personId;
		}
		modalRef.componentInstance.type = isNullish(this.catalogRoutingParams.catalogItemGuid) ? item.contactFormType : ContactFormType.CatalogItemContact;
	}


}
